import { cn } from '@/lib/utils'

interface BrandLogoProps {
  size?: 'header' | 'login'
  className?: string
}

export function BrandLogo({ size = 'header', className }: BrandLogoProps) {
  const sizeClasses = {
    header: 'text-xl font-semibold',
    login: 'text-2xl font-bold lg:text-3xl',
  }

  return (
    <h1 className={cn(sizeClasses[size], 'text-gray-900', className)}>
      White 🥋 Gi
    </h1>
  )
}
